/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountResDto } from '../../models/account-res-dto';
import { PaginatedDocumented } from '../../models/paginated-documented';

export interface AccountsControllerFindManyAccounts$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** -1
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by username query param.
   *
   * **Format:** filter.username={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.username=$btw:John Doe&filter.username=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.username'?: Array<string>;

  /**
   * Filter by mailVerified query param.
   *
   * **Format:** filter.mailVerified={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.mailVerified=$eq:John Doe&filter.mailVerified=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.mailVerified'?: Array<string>;

  /**
   * Filter by creationDate query param.
   *
   * **Format:** filter.creationDate={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.creationDate=$eq:John Doe&filter.creationDate=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.creationDate'?: Array<string>;

  /**
   * Filter by expireDate query param.
   *
   * **Format:** filter.expireDate={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.expireDate=$eq:John Doe&filter.expireDate=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.expireDate'?: Array<string>;

  /**
   * Filter by lastLogin query param.
   *
   * **Format:** filter.lastLogin={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.lastLogin=$eq:John Doe&filter.lastLogin=$gte:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gte
   *
   * - $lte
   *
   * - $and
   *
   * - $or
   */
  'filter.lastLogin'?: Array<string>;

  /**
   * Filter by persona.nome query param.
   *
   * **Format:** filter.persona.nome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.nome=$btw:John Doe&filter.persona.nome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.nome'?: Array<string>;

  /**
   * Filter by persona.cognome query param.
   *
   * **Format:** filter.persona.cognome={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.persona.cognome=$btw:John Doe&filter.persona.cognome=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.persona.cognome'?: Array<string>;

  /**
   * Filter by profiles.role.id query param.
   *
   * **Format:** filter.profiles.role.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.profiles.role.id=$eq:John Doe&filter.profiles.role.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.profiles.role.id'?: Array<string>;

  /**
   * Filter by status.id query param.
   *
   * **Format:** filter.status.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.status.id=$eq:John Doe&filter.status.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.status.id'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=username:DESC&sortBy=mailVerified:DESC
   *
   *
   * **Default Value:** username:ASC
   *
   * **Available Fields**
   * - username
   *
   * - mailVerified
   *
   * - creationDate
   *
   * - expireDate
   *
   * - lastLogin
   *
   * - persona.nome
   *
   * - persona.cognome
   *
   * - status.standardName
   */
  sortBy?: Array<
    | 'username:ASC'
    | 'username:DESC'
    | 'mailVerified:ASC'
    | 'mailVerified:DESC'
    | 'creationDate:ASC'
    | 'creationDate:DESC'
    | 'expireDate:ASC'
    | 'expireDate:DESC'
    | 'lastLogin:ASC'
    | 'lastLogin:DESC'
    | 'persona.nome:ASC'
    | 'persona.nome:DESC'
    | 'persona.cognome:ASC'
    | 'persona.cognome:DESC'
    | 'status.standardName:ASC'
    | 'status.standardName:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** username,mailVerified,creationDate,expireDate,lastLogin
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - username
   *
   * - mailVerified
   *
   * - creationDate
   *
   * - expireDate
   *
   * - lastLogin
   *
   * - persona.nome
   *
   * - persona.cognome
   *
   * - status.standardName
   */
  searchBy?: Array<string>;
}

export function accountsControllerFindManyAccounts(
  http: HttpClient,
  rootUrl: string,
  params?: AccountsControllerFindManyAccounts$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<AccountResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          username?: string | Array<string>;
          mailVerified?: string | Array<string>;
          creationDate?: string | Array<string>;
          expireDate?: string | Array<string>;
          lastLogin?: string | Array<string>;
          'persona.nome'?: string | Array<string>;
          'persona.cognome'?: string | Array<string>;
          'profiles.role.id'?: string | Array<string>;
          'status.id'?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    accountsControllerFindManyAccounts.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.username', params['filter.username'], {});
    rb.query('filter.mailVerified', params['filter.mailVerified'], {});
    rb.query('filter.creationDate', params['filter.creationDate'], {});
    rb.query('filter.expireDate', params['filter.expireDate'], {});
    rb.query('filter.lastLogin', params['filter.lastLogin'], {});
    rb.query('filter.persona.nome', params['filter.persona.nome'], {});
    rb.query('filter.persona.cognome', params['filter.persona.cognome'], {});
    rb.query('filter.profiles.role.id', params['filter.profiles.role.id'], {});
    rb.query('filter.status.id', params['filter.status.id'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<AccountResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                username?: string | Array<string>;
                mailVerified?: string | Array<string>;
                creationDate?: string | Array<string>;
                expireDate?: string | Array<string>;
                lastLogin?: string | Array<string>;
                'persona.nome'?: string | Array<string>;
                'persona.cognome'?: string | Array<string>;
                'profiles.role.id'?: string | Array<string>;
                'status.id'?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

accountsControllerFindManyAccounts.PATH = '/admin/accounts';
